import React, { SVGProps } from 'react'
const SvgUpload = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || 'var(--color-cta)'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M14 10v.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C12.48 14 11.92 14 10.8 14H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 12.48 2 11.92 2 10.8V10m9.333-4.667L8 2m0 0L4.667 5.333M8 2v8"
    />
  </svg>
)
export default SvgUpload
